<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <programa-subir-form @success="success"></programa-subir-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <programa-subir-form @success="success"></programa-subir-form>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'programa-subir-form': require('./ProgramaSubirForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
